import { render, staticRenderFns } from "./SubmitButton.vue?vue&type=template&id=4e892176&scoped=true&lang=pug&"
import script from "./SubmitButton.vue?vue&type=script&lang=js&"
export * from "./SubmitButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e892176",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/boyoon/Desktop/Project/kl3/wonderapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e892176')) {
      api.createRecord('4e892176', component.options)
    } else {
      api.reload('4e892176', component.options)
    }
    module.hot.accept("./SubmitButton.vue?vue&type=template&id=4e892176&scoped=true&lang=pug&", function () {
      api.rerender('4e892176', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "scripts/vue-components/buttons/SubmitButton.vue"
export default component.exports